var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"calc(100vh - 390px)"},attrs:{"id":"grafico-no-moving-v2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }